import React, { Component } from "react";
import { connect } from "react-redux";
import AOS from "aos";
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import Footer from "../Home/Component/Footer";
import Ready from "../../../components/Ready";
import Accordion from "../../../components/UI/Accordion";
import { Helmet } from "react-helmet";
import JsonData from "../../JsonData/jsonData.json";

class ResearchInsights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      formData: {
        'type': 'Individual'
      },
      activeTab: 'leading',
      activeTabTwo: "organizational",
      openIndex: null,
      individualOpenIndex: 0,
      organizationalOpenIndex: 0,
      // selectedImage: props.selectedImage || "",
      selectedImage: JsonData.individualInsights[0].image,
      selectedImagetwo: JsonData.organizationalInsights[0].image,
      showOrgTypeModal: false,
      hoveredElement: 1,
      hoveredElementtwo: 1,
      hoveredElementthree: 1,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.dispatch(assessmentActions.userAssessmentUserProfile('getAssessmentCartCount'));
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }
  handleHover = (element) => {
    this.setState({ hoveredElement: element });
  };
  handleHovertwo = (element) => {
    this.setState({ hoveredElementtwo: element });
  };

  handleHoverthree = (element) => {
    this.setState({ hoveredElementthree: element });
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  handleDownload = () => {
    let code = "TalentPlusStrengths21";
    const link = document.createElement("a");
    link.href = "/" + code.toString() + ".pdf";
    link.download = code.toString() + ".pdf";
    link.click();
  };

  handleRedirect = () => {
    this.props.history.push("/assessment/how-talentplus-strength-works");
    window.scrollTo(0, 0);
  };

  closeOrgTypeModal = () => {
    this.setState({ showOrgTypeModal: false })
  }


  handleOptionInput = (value) => {
    let { formData } = this.state;
    formData["type"] = value;
    this.setState({ formData });
  };

  handleOptionSubmit = () => {
    let { formData } = this.state;
    if (formData["type"] === "Individual") {
      this.props.history.push(`/assessment/` + "surveylogin");
    } else if (formData["type"] === "Organization") {
      window.location.href = 'https://plusinsight.happyplus.in/surveylink/#/assessment/signin';
    }
  };


  handleTakeAssessmentRedirect = () => {
    this.setState({ showOrgTypeModal: false }, () => {
      this.handleOptionSubmit();
    })
  }

  handleScrollToSection = () => {
    const section = document.getElementById("section2");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  }

  setActiveTabTwo = (tab) => {
    this.setState({ activeTabTwo: tab });
  };

  handleIndividualInsights = (index) => {
    this.setState((prevState) => ({
      individualOpenIndex: prevState.individualOpenIndex === index ? null : index,
      selectedImage:
        prevState.individualOpenIndex === index
          ? prevState.selectedImage
          : JsonData.individualInsights[index].image
    }));
  };

  handleOrganizationalInsights = (index) => {
    this.setState((prevState) => ({
      organizationalOpenIndex: prevState.organizationalOpenIndex === index ? null : index,
      selectedImagetwo:
        prevState.organizationalOpenIndex === index
          ? prevState.selectedImagetwo
          : JsonData.organizationalInsights[index].image
    }));
  };

  render() {

    const { activeTab, activeTabTwo } = this.state;

    let { assessment } = this.props;
    let { userAssessmentUserProfileData, getAssessmentCartCountData, getAssessmentPackagesShortListData } = assessment;

    const cards = [
      {
        title: "Behavioral Role Mapping",
        description:
          "AI analyzes individual behaviors, motivations, and cognitive patterns to create tailored role compatibility scores.",
        imageBlue: "/ResearchPaper/behavioral-role-mapping.svg",
        imageWhite: "/ResearchPaper/behavioral-role-mapping-white.svg",
      },
      {
        title: "AI Talent Fit Scoring",
        description:
          "Using machine learning models, TalentWeave quantifies innate talents and recommends top-fit candidates automatically.",
        imageBlue: "/ResearchPaper/aI-talent-fit-scoring.svg",
        imageWhite: "/ResearchPaper/aI-talent-fit-scoring-white.svg",
      },
      {
        title: "Real-Time Talent Intelligence",
        description:
          "Gain dynamic insights beyond skills — uncover agility, emotional intelligence, leadership potential, and more.",
        imageBlue: "/ResearchPaper/real-time-talent-intelligence.svg",
        imageWhite: "/ResearchPaper/real-time-talent-intelligence-white.svg",
      },
      {
        title: "Fitment and Gap Summary with GenAI",
        description:
          "Fit Summary describes how well a candidate’s strengths and personality traits align with the requirements of a role, Gap Summary outlines areas where the candidate may lack certain traits or skills needed for the role.",
        imageBlue: "/ResearchPaper/fitment-and-gap-summary-with-genai.svg",
        imageWhite: "/ResearchPaper/fitment-and-gap-summary-with-genai-white.svg",
      },
    ];

    return (
      <div className="overflow-hidden">

        <Helmet>
          <meta charSet="utf-8" />
          <title>TalentPlusStrengths – Discover Your Unique Strengths & Unlock Potential</title>
          <meta name="description" content="Take the TalentPlusStrengths assessment to uncover your core strengths. Align your career, leadership, and life choices with your natural talents." />
          <meta name="keywords" content="Employer solutions, strengths-based hiring, workplace development, talent optimization, leadership growthTalent assessment, personal strengths, career growth, leadership development, strengths-based coaching" />
          <meta name="author" content="TalentPlusStrengths" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="TalentPlusStrengths – Discover Your Unique Strengths & Unlock Potential" />
          <meta property="og:description" content="Take the TalentPlusStrengths assessment to uncover your core strengths. Align your career, leadership, and life choices with your natural talents." />
          <meta property="og:image" content="https://talentplusstrengths.com/img/TalentPlusStrengths_logo.svg" />
          <meta property="og:url" content="https://talentplusstrengths.com/#/assessment/home" />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://talentplusstrengths.com/#/assessment/home" />
        </Helmet>

        <section
          className="bg-[#2196F3]/10 w-full h-auto  bg-cover bg-no-repeat bg-right "
          style={{
            backgroundImage: `url('/img/assessment/bg-gradient.webp')`,
          }}
        >
          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />
          {/* Hero Section */}
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-10  md:pt-10  lg:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="flex flex-col justify-center w-full h-full pt-10 mx-auto my-auto space-y-8 text-center md:pb-10 md:pt-0 md:text-left">
                {/* <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest ">Employer Solutions</p> */}
                <h1 data-aos="fade-right" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121]  capitalize">Unleashing the Future of Talent Hiring with AI</h1>
                <h1 data-aos="fade-right" className="xl:text-2xl text-xl font-bold text-[#212121]  capitalize">TalentWeave: AI enabled Talent Hiring Fitment Engine for Role based Talent Matching.</h1>
                <div data-aos="fade-right" className="text-base font-light md:text-lg">
                  <p className="text-[#212121]">In today’s dynamic business landscape, traditional resumes fall short of capturing true potential. TalentWeave revolutionizes hiring by leveraging the power of AI-driven talent based behavioral analytics to uncover the innate strengths that fuel high performance.</p>
                </div>
                <div className="flex flex-row items-center justify-center gap-4 md:justify-start md:items-center">
                  <button data-aos="fade-right" onClick={() => this.gotoPage("contact-us")} className="bg-[#1976D2] hover:bg-[#1976D2] hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-150  text-white py-2.5 px-6 rounded uppercase cursor-pointer flex w-fit justify-center">Book a Demo</button>
                </div>
              </div>

              <div className="flex items-end justify-center w-full lg:justify-end">
                <img data-aos="fade-left" src="/ResearchPaper/research-insights.webp" alt="research-insights" className="z-0 w-full" />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#F9FAFB] py-16">
          <div className="w-full px-4 mx-auto space-y-6 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0 ">
            <div className="space-y-2">
              <h1 data-aos="fade-up" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121] capitalize">TalentWeave Key Highlights </h1>
            </div>
            <p data-aos="fade-up" className="md:text-lg text-base text-[#212121] md:w-[70%] w-full mx-auto">Why Talentweave is different : Nowadays, most AI-based hiring or recruitment tools focus solely on skill matching. However, hiring should also consider talent and behavioral traits to ensure the best fit.</p>
            <div className="pt-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {cards.map((card, index) => (
                  <div key={index} className="group bg-white rounded-2xl border p-6 hover:shadow-xl hover:bg-gradient-to-r from-[#1976D2] to-[#673AB7] transition duration-300">
                    <div className="flex items-start space-x-4">
                      <img src={card.imageBlue} className="w-12 h-12 block group-hover:hidden" alt={card.title} />
                      <img src={card.imageWhite} className="w-12 h-12 hidden group-hover:block" alt={card.title} />
                      <div className="text-left">
                        <h3 className="text-lg font-semibold text-gray-900 group-hover:text-white">{card.title}</h3>
                        <p className="textblack mt-2 group-hover:text-white">{card.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 mx-auto bg-white bg-center bg-no-repeat bg-cover 2xl:w-9/12 xl:w-11/12 xl:px-0 xl:bg-contain">
          <div className="pt-20 mx-auto space-y-6 text-center ">
            <h1 data-aos="fade-up" className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">4 Domains and 28 Themes of TalentPlusStrengths</h1>
            <p data-aos="fade-up" className="md:text-lg text-base text-[#212121]">
              Your customized TalentPlusStrengths reports will help you to
              experience new ways to understand what makes you so unique.
            </p>
          </div>
        </section>

        <section className="flex flex-col items-center justify-center w-full gap-10 px-4 pt-16 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row">
          <div className="flex flex-col items-center justify-start w-full gap-2 overflow-x-auto border-collapse md:flex-row md:justify-center whitespace-nowrap">
            <button
              className={`border text-[#212121] text-center py-4 px-4 cursor-pointer transition-all duration-150 md:w-56 w-full uppercase font-medium ${activeTab === 'leading'
                ? 'border-[#673AB7] border-b-4 hover:bg-[#ECE7F6]'
                : 'hover:bg-gray-100'
                }`}
              onClick={() => this.setActiveTab('leading')}
            >
              Leading Talents
            </button>
            <button
              className={`border text-[#212121] text-center py-4 px-4 cursor-pointer transition-all duration-150 md:w-56 w-full uppercase font-medium ${activeTab === 'thinking'
                ? 'border-[#FFC107] border-b-4 hover:bg-[#ECE7F6]'
                : 'hover:bg-gray-100'
                }`}
              onClick={() => this.setActiveTab('thinking')}
            >
              Thinking Talents
            </button>
            <button
              className={`border text-[#212121] text-center py-4 px-4 cursor-pointer transition-all duration-150 md:w-56 w-full uppercase font-medium ${activeTab === 'relating'
                ? 'border-[#4CAF50] border-b-4 hover:bg-[#ECE7F6]'
                : 'hover:bg-gray-100'
                }`}
              onClick={() => this.setActiveTab('relating')}
            >
              Relating Talents
            </button>
            <button
              className={`border text-[#212121] text-center py-4 px-4 cursor-pointer transition-all duration-150 md:w-56 w-full uppercase font-medium ${activeTab === 'action'
                ? 'border-[#2196F3] border-b-4 hover:bg-[#ECE7F6]'
                : 'hover:bg-gray-100'
                }`}
              onClick={() => this.setActiveTab('action')}
            >
              Action Talents
            </button>
          </div>
        </section>

        <div className="w-full mt-8 p-6 bg-white">
          {activeTab === 'leading' && (
            <>
              <div className="flex flex-col items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                <div data-aos="fade-right" className="w-full space-y-8">
                  <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">
                    What Is the Leading Domain of TalentPlusStrengths?
                  </h1>
                  <p className="text-lg text-[#212121]">These are the talents, which defines our leadership. Leadership is not a position but it is a mindset,
                    through which people share their vision with others, get them aligned and motivated and ensure work
                    takes place towards that desired future. Leaders are the people responsible for a better  tomorrow, so
                    they not only have to keep looking at the things to come but also make that dream a reality with the
                    help of others.</p>
                  <p className="text-lg text-[#212121]">Leaders are the people responsible for a better tomorrow, so
                    they not only have to keep looking at the things to come but also make that dream a reality with the
                    help of others</p>
                </div>
                <div className="w-full">
                  <img data-aos="fade-left" alt="talentplusleadingdomain" width={790} height={790} src="/img/Home/talentplusleadingdomain.webp" />
                </div>
              </div>
              <section className="items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                <div className="flex items-center justify-between w-full bg-white rounded-xl">
                  <div className="w-full space-y-4">
                    <div className="pb-5">
                      <h2
                        data-aos="fade-up"
                        className=" text-4xl leading-[3rem] xl:leading-[4rem] font-medium text-[#212121] border-l-[0.4rem] border-[#673AB7] pl-6 capitalize"
                      >
                        Learn More About Each Leading TalentPlusStrengths Theme:
                      </h2>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Confidence
                      </h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You are someone who knows where your life is going. You
                          are in control of things happening in your life. You feel
                          you have a compass which guides you in which direction you must go. People may suggest but it's you who decides
                          your next step.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="confident" src="/img/domaim/confident.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Enhancer
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          People with this theme would love to work on something
                          already good and try to make it the best. Not only with
                          people but with processes, products or anything which
                          comes in front of them. They believe in enhancing things
                          with their effort, talent, and determination.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="enhancer" src="/img/domaim/enhancer.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>

                    <div data-aos="fade-up" className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Generalship
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You are a great problem solver, so much so that you do not
                          consider any problem as a problem. Not only will you solve
                          a problem but you can do it in multiple ways. This immense
                          ability can make others wonder, when they are still
                          thinking of any issue, you have already solved it. How? No
                          one knows it.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="ideation" src="/img/domaim/ideation.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Starter
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          When can we move is the question you constantly ask
                          yourself and others. Driven by this talent there is never
                          a dull moment in your life. In fact, you are always onto
                          something because you believe at the end of the day, it is
                          the action which trumps all the words.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="starter" src="/img/domaim/starter.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Speaker
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You love speaking. You love connecting with people. Words
                          are the glue which allows people to get attracted to you.
                          You love stories, anecdotes, and examples to make a point
                          and people are always in awe when you speak. You can
                          inspire people with your words
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="speaker" src="/img/domaim/speaker.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Winner
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You play to win. You want to be numero uno. You love to
                          compete. You love to compare. Wherever you are, you will
                          ensure that your team is driven to aspire big. You
                          will love to bring your best and get others to do
                          their best, because you know to win, you need to be the
                          best
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="winner" src="/img/domaim/winner.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#673AB7]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]">Convincer</h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">Charismatic connector who thrives on attention, energizes spaces, and excels at building rapport. Skilled in initiating conversations, influencing others, and inspiring belief through charm and engaging communication. Success lies in creating meaningful connections and leaving a lasting impression.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="winner" src="/img/domaim/convincer.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

          {activeTab === 'thinking' && (
            <>
              <section ref={this.section2Ref}>
                <div className="flex flex-col items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                  <div className="w-full">
                    <img
                      alt="talentplusthinkingdomain"
                      data-aos="fade-right"
                      src="/img/Home/talentplusthinkingdomain.webp"
                      width={790}
                      height={790}
                    />
                  </div>
                  <div data-aos="fade-left" className="w-full space-y-8">
                    <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">
                      What Is the Thinking Domain of TalentPlusStrengths?
                    </h1>
                    <p className="text-[#212121]">These are the talents which define your way of thinking and making sense of the world. Using these
                      talents, you deliberate on ideas, possibilities, and the next course of action. This theme deals with
                      intellectual abilities which is the hallmark of human progress. </p>
                    <p className="text-[#212121]">Thinking about themes allows us to
                      explore our past and gaze into the future so that we can plan things in the present. Thinking talents
                      are the strategic pathway to our future.</p>
                  </div>
                </div>
              </section>

              <section className="items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                <div className="flex items-center justify-between w-full bg-white rounded-xl">
                  <div className="w-full space-y-4">
                    <div className="pb-5">
                      <h2
                        data-aos="fade-up"
                        className=" text-4xl leading-[3rem] xl:leading-[4rem] font-medium text-[#212121] border-l-[0.4rem] border-[#FFC107] pl-6 capitalize"
                      >
                        Learn More About Each Thinking TalentPlusStrengths Theme:
                      </h2>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Logical
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You love numbers. You love data. You love patterns. You
                          love solving problems. But you know before you solve a
                          problem you need to go to the root cause of the problem
                          and that is something which provides you with a talent to
                          ask probing questions.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="logical" src="/img/domaim/logical.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Philosopher
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You have a mind which loves thinking. Frankly you can
                          think of anything. The sheer thrill of picking up a topic
                          and giving your own spin will excite you. You may speak
                          less but when you speak people will listen because they
                          know, unless you have anything valuable, you will not
                          speak.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="philosopher" src="/img/domaim/philosopher.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#212121]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%] capitalize">solver</h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121]">People with this theme have a superior ability to solve any problem in life effortlessly, that too in multiple ways. Sovlers live their life with confidence and also brings calmness in difficult situations</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="ideation" src="/img/domaim/solver.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl w-[20%]">Disruptor</h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          Ideas are fascinating. In fact, it is the ideas which
                          make  the world tick. Everything which is available in
                          front of us is someone's idea. Driven by these thoughts,
                          you always want to do things in different ways and look at
                          solving problems in a way in which it was never done.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="strategic" src="/img/domaim/strategic.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Quencher
                      </h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          The power of curiosity drives you. You believe, life is
                          about learning and knowing new things. New ideas and
                          concepts excite you. Not only learning new things but
                          sharing the same with others is a great experience and you
                          do it abundantly.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="strategic" src="/img/domaim/quencher.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl w-[20%]">Forecaster</h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">Visionary and intuitive, adept at foreseeing future possibilities and inspiring others to pursue them. A dreamer who combines vivid imagination with hard work, motivates positive change, and builds success by anticipating and shaping the future.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="strategic" src="/img/domaim/forecaster.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#FFC107]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl w-[20%]">Reinstate</h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121]">Problem-solver driven by challenges, excels at fixing what's broken and turning around difficult situations. Focused, determined, and energized by crises, with a deep analytical approach. Finds fulfillment in reviving hopeless causes, earning admiration for restoring success and ensuring survival.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="strategic" src="/img/domaim/reinstate.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

          {activeTab === 'relating' && (
            <>
              <section ref={this.section3Ref}>
                <div className="flex flex-col items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                  <div data-aos="fade-right" className="w-full space-y-8">
                    <h1
                      data-aos="fade-up"
                      className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]"
                    >
                      What Is the Relating Domain of TalentPlusStrengths?
                    </h1>
                    <p className="text-[#3D405B]">Human beings are social animals. We thrive with others. We need others in life to share our successes,
                      miseries, and our condition. The ability to connect with others is what defines the possibilities of our
                      success in life. </p>
                    <p className="text-[#3D405B]">It is the bond between one person and another, which takes us higher and ensures we
                      come together to achieve the goals we set for ourselves, challenges we want to overcome and write
                      history together.</p>
                  </div>
                  <div className="w-full">
                    <img
                      alt="talentplusrelatingdomain"
                      data-aos="fade-left"
                      src="/img/Home/talentplusrelatingdomain.webp"
                      width={790}
                      height={790}
                    />
                  </div>
                </div>
              </section>

              <section className="items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                <div className="flex items-center justify-between w-full bg-white rounded-xl">
                  <div className="w-full space-y-4">
                    <div className="pb-5">
                      <h2
                        data-aos="fade-up"
                        className=" text-4xl leading-[3rem] xl:leading-[4rem] font-semibold text-[#212121] border-l-[0.4rem] border-[#4CAF50] pl-6"
                      >
                        Learn More About Each Relating TalentPlusStrengths Theme:
                      </h2>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Binder
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          People like you because you are like a glue which binds
                          the relationship among them. Driven by the talent of
                          binder, you connect at a deep level with very few people
                          and these are the ones  who know that you are such a gem
                          of a person who is ready to do anything for them.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="binder" src="/img/domaim/binder.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Equaliser
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          People with this talent like to see areas of synergies in
                          every situation. They would love to know where we all
                          agree so that we can build a relationship  which allows us to
                          take on the differences. People like you because you would
                          love to solve things rather than confront them.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="empathiser" src="/img/domaim/empathiser.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Coach
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base ">
                          You are unique in the sense that you see potential in
                          everyone. You know, everyone can achieve greatness, only
                          if they put in the effort and of course with your support. You
                          want your pupils to go ahead of you and in that progress,
                          you see your own progress
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="coach" src="/img/domaim/coach.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Kindness
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You can sense the feeling; you can sense the emotions.
                          In fact, you can put yourself in the shoes of someone else
                          and feel the same way the other person is feeling. This
                          power of yours allows you to anticipate and operate with
                          people the way they want it to be.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="harmonise" src="/img/domaim/harmonise.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Optimistic
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          For you life is always beautiful. In good times and in bad
                          times, you never lose hope. You know things will be
                          all right. You have immense gratitude for whatever you have
                          and a mind which always tells you, nothing is impossible.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="positive" src="/img/domaim/positive.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">Interrelation</h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">Insightful connector who sees the hidden interconnections in life, guided by a strong sense of karma and mindfulness. Offers unconventional solutions, often misunderstood but deeply meaningful. Reserved yet impactful, earns respect for wisdom and unique problem-solving perspectives.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="positive" src="/img/domaim/Interrelator.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#4CAF50]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">Flexible</h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">Present-focused and adaptable, thrives on spontaneity and embraces life’s adventures. Grateful, positive, and calm, encourages enjoyment while blending seamlessly into any situation. Balances flexibility with conviction, inspiring others to see life as an exciting journey.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="positive" src="/img/domaim/flexible.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

          {activeTab === 'action' && (
            <>
              <section ref={this.section4Ref} className="px-6 space-y-16 md:px-0">
                <div className="flex flex-col items-center w-full gap-10 py-16 mx-auto 2xl:w-9/12 xl:w-11/12 md:flex-row ">
                  <div className="w-full">
                    <img
                      alt="talentplusactingdomain"
                      data-aos="fade-right"
                      src="/img/Home/talentplusactingdomain.webp"
                      width={790}
                      height={790}
                    />
                  </div>
                  <div data-aos="fade-left" className="w-full space-y-8">
                    <h1
                      data-aos="fade-up"
                      className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]"
                    >
                      What Is the Acting Domain of TalentPlusStrengths?
                    </h1>
                    <p className="md:text-lg text-[#3D405B]">These are action talents, which allow you to make things happen. Ideas are good but the real
                      progress takes place when we put these ideas to action. The acting talent allows us to put our
                      thoughts into action and see the magic happen.</p>
                    <p className="md:text-lg text-[#3D405B]">It is these themes which make things happen and
                      lets everyone see the progress happening. Our acting talents ensure that we make progress and
                      finish tasks and achieve things consistently.</p>
                  </div>
                </div>
              </section>

              <section className="items-center w-full gap-10 px-4 py-10 mx-auto md:py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 md:flex-row ">
                <div className="flex items-center justify-between w-full bg-white rounded-xl">
                  <div className="w-full space-y-4">
                    <div className="pb-5">
                      <h2
                        data-aos="fade-up"
                        className=" text-4xl leading-[3rem] xl:leading-[4rem] font-semibold text-[#212121] border-l-[0.4rem] border-[#2196F3] pl-6 capitalize"
                      >
                        Learn More About Each Acting TalentPlusStrengths Theme:
                      </h2>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Finisher
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You are someone who has a humongous capacity to work. People can't match your energy and enthusiasm. Once you start something, you would like to finish. You take pride in what you do and often you achieve quite a lot in your day.

                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="finisher" src="/img/domaim/finisher.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Concentrator
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          Like a Zen master, once you have decided to do something,
                          you will not buzz from your path. Your mind is as sharp as
                          a razor and allows you to accomplish things, once you have
                          set sight on it. It is like a horse with a blinder, moving
                          forward till it reaches its destination.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="focus" src="/img/domaim/focus.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Multitask
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          Multitaskers are like jugglers managing multiple balls in one go. In fact, the more balls in the hand and air, the more excitement they will experience. At one go they can be focused on many things and will finish everything with perfection.

                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="multitask" src="/img/domaim/multitask.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Owner
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You take psychological ownership of everything you do. You take extreme care in delivering anything you have committed and expect the same from others. No one can match you for the perfection you deliver, because you yourself can criticise yourself before anyone else can.

                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="owner" src="/img/domaim/owner.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]"
                    >
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">
                        Planner
                      </h1>

                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          You need structure in life. You can build sanity in chaos.
                          Driven by your talent of putting things in their place, you
                          are known for your no-nonsense attitude and get things
                          done, the way they should be done, that too in a perfect
                          manner.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="planner" src="/img/domaim/planner.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl  w-[20%]  ">Value</h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121] ">
                          People with deep values lead their life with certain
                          non-negotiable principles. Whatever happens in life those
                          core principles will not change. In fact, that is the map
                          which guides their journey called life. They would be
                          known for the character and unmistakable morality.
                        </p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="value" src="/img/domaim/value.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                    <div data-aos="fade-up" className="items-center bg-[#2196F3]/10 justify-between p-4 space-y-4 rounded-2xl 2xl:px-8 md:py-4 md:flex md:space-x-6 md:space-y-0 text-[#3D405B]">
                      <h1 className="text-xl font-medium 2xl:text-2xl w-[20%]">Cautious</h1>
                      <div className="md:w-[80%] flex  space-x-6 md:items-center items-end ">
                        <p className="flex-1 text-sm font-normal md:text-base text-[#212121]">Risk-aware and cautious, excels at identifying and mitigating potential threats. Prioritizes safety, analyzes plans meticulously, and avoids recklessness. Selective and reserved, earns respect for preventing unseen dangers and ensuring security in all aspects of life.</p>
                        <div className="w-16 xl:w-28 md:w-20">
                          <img alt="value" src="/img/domaim/cautious.svg" width={96} height={96} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </div>

        <section className="bg-[#F9FAFB] py-16">
          <div className="w-full px-4 mx-auto space-y-6 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0">

            <h1 className="2xl:text-5xl md:text-4xl text-3xl capitalize font-bold textblack text-center pb-5">Hiring Reports and Insights</h1>

            <div className="w-full mx-auto">
              <div className="w-fit mx-auto bg-white flex justify-center md:gap-4 gap-2 mb-8 border border-[#212121] p-2 rounded-full">
                <button onClick={() => this.setActiveTabTwo("organizational")} className={`md:px-6 px-2 py-2 md:text-base text-sm font-semibold rounded-full ${activeTabTwo === "organizational" ? "bg-[#212121] text-white" : "textblack hover:bg-gray-100"}`}>Overall Insight</button>
                <button onClick={() => this.setActiveTabTwo("individual")} className={`md:px-6 px-2 py-2 md:text-base text-sm font-semibold rounded-full ${activeTabTwo === "individual" ? "bg-[#212121] text-white" : "textblack hover:bg-gray-100"}`}>Individual Insight</button>
              </div>
            </div>

            <div className="pt-6">
              {activeTabTwo === "organizational" && (
                <section className="">
                  <div className="mx-auto grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
                    <div className="flex items-center justify-center w-full md:pr-8 pr-0 lg:block hidden">
                      <img data-aos="fade-left" src={this.state.selectedImagetwo} alt="Lead with Clarity" className="z-0 shadow-lg" />
                    </div>
                    <div className="w-full">
                      <h2 className="2xl:text-5xl md:text-4xl text-3xl capitalize font-bold textblack text-start">Hiring Overall Insights</h2>
                      <p className="text-lg text-[#212121] pt-4 text-left">Overall detailed analysis of the candidate’s potential suitability for the role by evaluating the alignment between role-specific talent theme requirements and the candidate’s personal talent themes or behavioral tendencies. The insights are derived from the individual’s talent assessment survey results, which identify dominant behavioral patterns, strengths, and preferences.</p>
                      <div className="text-left text-[#212121] pt-4">
                        <ul className="space-y-3">
                          <li><b>Role-wise Talent Themes Requirement</b> – the critical competencies and behavioral attributes, necessary for success in the specific role.</li>
                          <li><b>Individual Talent Themes</b> – the unique strengths and talents identified through the candidate’s assessment profile.</li>
                        </ul>
                      </div>
                      <div className="py-6">
                        {JsonData.organizationalInsights.map((item, index) => (
                          <Accordion
                            key={index}
                            title={item.title}
                            description={item.description}
                            para={item.para}
                            list={item.list}
                            icon={item.icon}
                            img={this.state.selectedImagetwo}
                            isOpen={this.state.organizationalOpenIndex === index}
                            onClick={() => this.handleOrganizationalInsights(index)}
                            {...item}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {activeTabTwo === "individual" && (
                <section className="">
                  <div className="mx-auto grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
                    <div className="flex items-center justify-center w-full md:pr-8 pr-0 lg:block hidden">
                      <img data-aos="fade-left" src={this.state.selectedImage} alt="Lead with Clarity" className="z-0 shadow-lg" />
                    </div>
                    <div className="w-full">
                      <h2 className="2xl:text-5xl md:text-4xl text-3xl capitalize font-bold textblack text-start">Hiring Individual Insights</h2>
                      <p className="text-lg text-[#212121] pt-4 text-left">Individual analysis of the candidate’s potential suitability for the role by evaluating the alignment between role-specific talent theme requirements and the candidate’s personal talent themes or behavioral tendencies. The insights are derived from the individual’s talent assessment survey results, which identify dominant behavioral patterns, strengths, and preferences.</p>
                      <div className="text-left text-[#212121] pt-4">
                        <ul className="space-y-3">
                          <li><b>Role-wise Talent Themes Requirement</b> – the critical competencies and behavioral attributes, necessary for success in the specific role.</li>
                          <li><b>Individual Talent Themes</b> – the unique strengths and talents identified through the candidate’s assessment profile.</li>
                        </ul>
                      </div>
                      <div className="py-6">
                        {JsonData.individualInsights.map((item, index) => (
                          <Accordion
                            key={index}
                            title={item.title}
                            description={item.description}
                            para={item.para}
                            list={item.list}
                            icon={item.icon}
                            img={this.state.selectedImage}
                            isOpen={this.state.individualOpenIndex === index}
                            onClick={() => this.handleIndividualInsights(index)}
                            {...item}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="w-full px-4 mx-auto space-y-6 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <div className="overflow-hidden">
              <div className="grid lg:grid-cols-3 grid-cols-1 md:gap-8 gap-0 text-left">
                <div className="col-span-1 h-auto md:pb-0 pb-4">
                  <h2 className="text-4xl font-bold leading-snug textblack text-left">Solve Key Hiring Challenges With TalentWeave</h2>
                </div>
                <div className="col-span-2 h-auto md:pb-0 pb-4">
                  <p className="textblack md:leading-relaxed text-left md:text-xl text-base">Most AI-based hiring and recruitment tools focus exclusively on skill matching, overlooking critical factors such as talent potential and behavioral traits, which are essential for identifying the best overall fit for a role and long-term organizational success.</p>
                </div>
                <div className="col-span-1 space-y-2">

                  <div className="bg-[#EE6666] text-white text-xl font-semibold p-4 text-center">Problem</div>
                  <div className="bg-[#212121]/5 p-4 font-semibold textblack">Resume Overload & Bias</div>
                  <div className="bg-[#212121]/5 p-4 font-semibold textblack">Misaligned Hires</div>
                  <div className="bg-[#212121]/5 p-4 font-semibold textblack">Time-Consuming Screening</div>
                  <div className="bg-[#212121]/5 p-4 font-semibold textblack">Lack Of Human-Centric Insights</div>
                </div>
                <div className="col-span-2 space-y-2 md:pt-0 pt-5">

                  <div className="bg-[#42A5F5] text-white text-xl font-semibold p-4 text-center">TalentWeave Solution</div>
                  <div className="bg-[#212121]/5 p-4 textblack">AI Filters Candidates Based On Behavioral Relevance Fitment Score, Not Keywords.</div>
                  <div className="bg-[#212121]/5 p-4 textblack">Deep–Fit Analysis Ensures Compatibility With Role Expectations.</div>
                  <div className="bg-[#212121]/5 p-4 textblack">Automated Fit–Scoring Accelerates Shortlisting And Decision–Making.</div>
                  <div className="bg-[#212121]/5 p-4 textblack">AI Evaluates Personality Dynamics, Enabling More Empathetic Hiring.</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="w-full px-4 mx-auto space-y-6 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0 ">
            <div className="w-full h-auto  bg-cover bg-no-repeat bg-right px-8 py-16 rounded-2xl" style={{ backgroundImage: `url('/ResearchPaper/bg-img.webp')`, }}>
              <div className="text-left text-white">
                <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold">The AI Talent Revolution is Here</h2>
                <div className="py-6 space-y-3">
                  <p className="text-xl font-semibold">Hire Smarter.</p>
                  <p className="text-xl font-semibold">Hire With Purpose.</p>
                  <p className="text-xl font-semibold">Hire With TalentWeave.</p>
                </div>
                <button onClick={() => this.gotoPage("contact-us")} className="bg-[#2196F3] text-white font-semibold px-6 py-3 rounded-lg shadow hover:bg-[#1976D2] transition">
                  Get Started With TalentWeave
                </button>
              </div>
            </div>
          </div>

        </section>

        <Ready />

        <Footer props2={this.props} prodList={getAssessmentPackagesShortListData} gotoMyAccount={this.gotoMyAccount} />
      </div>
    );
  }
}

ResearchInsights.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(ResearchInsights);
